export default "__VITE_ASSET__3d089edf__"